import React from 'react';
import {
	TooltipHostCompat as TooltipHost,
	StackCompat as Stack,
	TextCompat as Text,
	IconButtonCompat as IconButton,
	Theme,
	useTheme,
	mergeStyleSets,
} from 'components/FluentUICompat';
import {useStore} from 'react-context-hook';
import {useTranslation} from 'react-i18next';
import {FaqPanelMode, IFaqState} from './FaqPanel';
import {IQuestionEntity} from './CreateQuestionDialog';

export interface IFaqComponentProps {
	questions: any[];
	entity: IQuestionEntity;
	parentId?: string;
}

export const FaqComponent: React.FC<IFaqComponentProps> = ({
	questions,
	entity,
	parentId,
}: any) => {
	const {t} = useTranslation('common/faq');
	const theme: Theme = useTheme();

	const [faqPanelState, setFaqPanelState] = useStore<IFaqState>('faq-panel', {
		mode: FaqPanelMode.Closed,
		entity: undefined,
		parentId: undefined,
		showPanel: false,
	});

	const classNames = mergeStyleSets({
		arrayItem: {
			borderRadius: '10px',
			color: theme?.palette.white,
			background: theme?.palette.red,

			fontSize: 12,
			padding: '2px 7px',
			marginRight: 5,
			marginBottom: 10,
			whiteSpace: 'nowrap',
		},
		arrayButton: {
			cursor: 'pointer',
		},
	});

	return (
		<div>
			<TooltipHost
				key={`faq`}
				styles={{
					root: {
						cursor: 'pointer',
					},
				}}
				tooltipProps={{
					onRenderContent: () => (
						<Stack
							styles={{
								root: {
									cursor: 'pointer',
								},
							}}
						>
							<Text
								variant='medium'
								onClick={() => {
									setFaqPanelState({
										mode: FaqPanelMode.EntityList,
										entity,
										parentId,
										showPanel: true,
									});
								}}
							>
								{t('OpenFaq')}
							</Text>
						</Stack>
					),
				}}
			>
				<div
					style={{display: 'flex'}}
					onClick={() => {
						setFaqPanelState({
							mode: FaqPanelMode.EntityList,
							entity,
							parentId,
							showPanel: true,
						});
					}}
				>
					<IconButton
						iconProps={{
							iconName: 'Chat',
							styles: {
								root: {
									color: theme.palette.black,
								},
							},
						}}
					/>

					<div>
						<Text
							className={`${classNames.arrayItem} ${classNames.arrayButton}`}
						>
							{questions?.count}
						</Text>
					</div>
				</div>
			</TooltipHost>
		</div>
	);
};
